<div class="container">
	<div class="classification-card">
		<div class="row">
			<div class="col card p-3 m-3">
				<span class="title text-center">Grupo: {{ group.name }}</span>
				<div *ngFor="let c of group.classifications">
					<app-eligible-filter-view [classification]="c"></app-eligible-filter-view>
				</div>
			</div>
		</div>
	</div>
</div>
